<div class="empty-default-container" *ngIf="!isInputsModuleVisible()">
  <div class="msg-container" *ngIf="!areInputsloading()">
    <span class="default-msg">{{ emptyModuleMessage() }}</span>
  </div>

  <div class="loading-inputs-msg" *ngIf="areInputsloading()">
    <span class="text-with-dots">
      The inputs table is loading, please wait
      <span class="dots-loader">
        <fa-icon [icon]="faCircle" class="dot dot1"></fa-icon>
        <fa-icon [icon]="faCircle" class="dot dot2"></fa-icon>
        <fa-icon [icon]="faCircle" class="dot dot3"></fa-icon>
      </span>
    </span>
  </div>
</div>

<app-notification-popup [isVisible]="isNotificationPopupOpen" (close)="closeNotificationPopup()"
  [errorMessage]="errorMessage()" [secondErrorMessage]="secondErrorMessage()"></app-notification-popup>

<div class="model-inputs" *ngIf="isInputsModuleVisible()">

  <app-chevron-confirm-popup
    [visible]="isChevronConfirmOpen()"
    (visibleChange)="isChevronConfirmOpen.set($event)"
    [title]="'Confirm'"
    [message]="chevronConfirmMessage()"
    [loadingBaseline]="loadingBaseline()"
    [preparing]="preparingChevronConfirm()"
    [saving]="savingChevron()"
    [lastModifiedBy]="chevronConfirmDetails().lastModifiedBy"
    [lastModifiedAtUtc]="chevronConfirmDetails().lastModifiedAt"
    [diffs]="chevronConfirmDetails().diffs"
    [auditTrail]="chevronAuditTrail().changes"
    (cancel)="cancelChevronSave()"
    (accept)="confirmChevronSave()"
  ></app-chevron-confirm-popup>

  <app-modal-create-scenario [isVisible]="isModalOpen()" (isVisibleChange)="isModalOpen.set($event)"
    (close)="closeModal()" [columns]="inputColumns()" (addColumn)="addColumn($event)"
    [baseScenario]="baseScenario()" (baseScenarioChange)="baseScenario.set($event)"></app-modal-create-scenario>


  <div class="message-wrapper" *ngIf="!inputsVisible()">
    <div class="msg-container">
      <span class="default-msg">{{ emptyModuleMessage() }}</span>
    </div>
  </div>

  <div class="section-title model-inputs-title" *ngIf="inputsVisible()"><span>Model inputs</span></div>
  <div class="model-predictions-content-container" *ngIf="inputsVisible()">

    <div class="table-container">
      <div class="table-wrapper">

        <app-inputs-table class="model-predictions-inputs-table" [columns]="inputColumns" [rows]="inputRows"
          (deleteColumn)="deleteColumn($event)" (valueChanged)="onValueChanged($event)"
          [canEditChevronCase]="canEditChevronCase" [chevronDirty]="chevronDirty()" [savingChevron]="savingChevron()"
          [preparingChevronConfirm]="preparingChevronConfirm()" [resetting]="isResetSpinnerVissible() || isDateSpinnerVissible()" (saveChevron)="saveChevronChanges()"></app-inputs-table>


      </div>
      <div class="add-column-wrapper">
        <button class="add-column-btn formated-button add-button" (click)="openAddColumnPopUp()"
          pTooltip="Add a custom column" tooltipPosition="bottom">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
      </div>
    </div>
    <div class="column-container">
      <div class="top-container">
        <div class="date-picker-container">
          <p-datepicker appendTo="body" [(ngModel)]="date" [showIcon]="true" [showOnFocus]="false" inputId="buttondisplay"
            placeholder="Select run date" (onSelect)="onDateChange($event)" [readonlyInput]="true" [disabled]="isResetSpinnerVissible() || isDateSpinnerVissible()" />
        </div>
        <div class="run-button-container">
          <!-- <button 
              class="run-button formated-button"
              [disabled]="isRunButtonDisabled()"
              [ngClass]="isRunButtonDisabled() ? 'inactive-button' : 'active-button'"
              (click)="runModel()">Run model</button> -->

          <app-loading-button class="model-predictions-run-button" [label]="'Run model'"
            [isLoading]="runButtonLoading()" [isDisabled]="isRunButtonDisabled() || isResetSpinnerVissible() || isDateSpinnerVissible()" (clicked)="runModel()"
            [customClass]="'model-predictions-run-button'"></app-loading-button>

        </div>
        <div class="reset-button-container">
          <button class="reset-button formated-button" [disabled]="isResetButtonDisabled() || isResetSpinnerVissible() || isDateSpinnerVissible()" (click)="resetValues()">
            <ng-container *ngIf="isResetSpinnerVissible() || isDateSpinnerVissible(); else resetLabelOnly">
              <fa-icon [icon]="faSpinner" class="fa-spin"></fa-icon>
            </ng-container>
            <ng-template #resetLabelOnly>
              <span>Reset values</span>
            </ng-template>
          </button>
        </div>

      </div>

      <div class="color-references-container" *ngIf="inputsVisible()">
        <div class="color-references-title">Table references</div>
        <ng-container *ngFor="let category of rowsCategories()">
          <div class="bullet-container {{ category }}-row">
            <span class="bullet"><fa-icon [icon]="['fas', 'circle']"></fa-icon></span>
            <span class="category-text">{{ category }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>


<div *ngIf="isResultVisible() " class="separator"></div>

<div *ngIf="isResultVisible() && rowsResults().length > 0" class="model-results">
  <div class="section-title  model-results-title"><span>Model results</span></div>
  <div class="model-predictions-results-container">
    <div class="table-results-container">
      <div class="table-results-wrapper">

        <app-results-table class="model-predictions-results-table" [columnsResults]="columnsResults"
          [rowsResults]="rowsResults"></app-results-table>
      </div>

    </div>
    <div class="column-results-container">
      <div class="chart-button-container">
        <button class="chart-button formated-button" (click)="openChartsWindow()">See charts</button>
      </div>

      <app-model-charts [isVisible]="isChartsModalOpen" (close)="closeModal()" [columnsResults]="columnsResults"
        [rowsResults]="rowsResults"></app-model-charts>

    </div>
  </div>
</div>